import { Component } from '@angular/core';
import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-file-upload',
  templateUrl: './formly-file-upload.component.html',
  styleUrl: './formly-file-upload.component.scss',
})
export class FormlyFileUploadComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: {
      btnClass: 'info text-white',
      iconClass: 'fa fa-file-upload',
      text: $localize`Import`,
      dropDownIconClass: 'fa fa-file-download',
    },
  };

  select(file: HTMLInputElement) {
    if (this.props.select) {
      this.props.select(file.files[0]);
    }
  }

  dropDown() {
    this.props.dropDown();
  }
}
